export default __webpack_public_path__ + "locales/si/DeleteThirdPartyDialog.json?hash=21de6968ea744c20a2152ba36062b84b";